import React, { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { Callout, FormGroup, H2 } from "@blueprintjs/core";

import { authenticatedGetFetch } from "../../utils/AuthenticatedFetch";
import { ParkSelect } from "../Structure/ParkSelector";
import { TimePrecision } from "@blueprintjs/datetime";
import { DateInput3 } from "@blueprintjs/datetime2";
import i18next from "i18next";
import { mefMontant } from "../../utils/mef";

export default function PriceCalculation(props) {
  const [park, setPark] = useState(undefined);
  const [start, setStart] = useState(new Date().toISOString());
  const [end, setEnd] = useState(new Date().toISOString());
  const [result, setResult] = useState(undefined);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (park) {
      setError(false);
      authenticatedGetFetch(
        "/tarif/calculate?" +
          new URLSearchParams({
            srv: park?.server?.id,
            park: park?.id,
            entry: start,
            exit: end,
          }),
        (response) => setResult(response),
        null,
        null,
        (err) => setError(true)
      );
    }
  }, [park, start, end]);

  return (
    <Callout title={<Trans>price calculation</Trans>}>
      <div className="flexbox-center-large">
        <div>
          <ParkSelect onSelect={(parkid, park) => setPark(park)} />

          <FormGroup
            label={<Trans>start date:</Trans>}
            labelFor="start_date"
            inline={true}
          >
            <DateInput3
              id="start_date"
              value={start}
              timePrecision={TimePrecision.MINUTE}
              formatDate={(date) => date.toLocaleString(i18next.language)}
              parseDate={(str) => new Date(str)}
              onChange={(time) => setStart(new Date(time).toISOString())}
              showTimezoneSelect={false}
              locale={i18next.language}
              closeOnSelection={false}
            />
          </FormGroup>

          <FormGroup
            label={<Trans>end date:</Trans>}
            labelFor="end_date"
            inline={true}
          >
            <DateInput3
              id="end_date"
              value={end}
              timePrecision={TimePrecision.MINUTE}
              formatDate={(date) => date.toLocaleString(i18next.language)}
              parseDate={(str) => new Date(str)}
              onChange={(time) => setEnd(new Date(time).toISOString())}
              showTimezoneSelect={false}
              locale={i18next.language}
              closeOnSelection={false}
            />
          </FormGroup>
        </div>
        <div>
          {!error && result !== undefined && (
            <Callout intent="success">
              <H2>{mefMontant(result?.amount || 0)}</H2>
            </Callout>
          )}
          {error && (
            <Callout intent="warning">
              <H2>
                <Trans>can't perform fare calculation</Trans>
              </H2>
            </Callout>
          )}
        </div>
      </div>
    </Callout>
  );
}
